/** Preserve the selected public membership through the existing sign-in
 * route. This is NOT a price quote or purchase authority. */
const key='ecfs.public.pendingMembership.v1';
const uuid=/^[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
export function savePendingMembership(location:string,productId:string){
  if(!/^[A-Z0-9_-]{2,64}$/.test(location)||!uuid.test(productId))return;
  try{window.sessionStorage.setItem(key,JSON.stringify({
    location,productId,savedAt:Date.now()}));}catch{/* no financial data */}
}
export function readPendingMembership(location:string):string|null{
  try{
    const raw=window.sessionStorage.getItem(key);
    if(!raw)return null;
    window.sessionStorage.removeItem(key);
    const item=JSON.parse(raw) as {location:string;productId:string;savedAt:number};
    return item?.location===location&&uuid.test(item.productId)&&
      Number.isFinite(item.savedAt)&&item.savedAt<=Date.now()+60000&&
      Date.now()-item.savedAt<15*60*1000?item.productId:null;
  }catch{return null;}
}
